/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Module for Custom Rep/Covering Cell.
 * @module src/Events/EventsList
 */
/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';

interface Quantity {
  quantity: string;
  availablequantity: string;
  productdescription: string;
  createdByDetails: any[];
  id: string;
  isOpen: boolean;
  needToDisplay: boolean;
}
interface Props {
  item?: Quantity;
}

const PartDescriptionCell: FC<Props> = ({
  item = {
    quantity: '',
    availablequantity: '',
    productdescription: '',
    createdByDetails: [],
    id: '',
    isOpen: false,
    needToDisplay: false,
  },
}) => {
  const {
    quantity,
    availablequantity,
    productdescription,
    createdByDetails,
    isOpen,
    needToDisplay,
  } = item;

  return needToDisplay ? (
    <DataTableCell title={productdescription} className="center-align">
      {quantity !== availablequantity ? (
        <div style={{ color: 'red', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {productdescription}
        </div>
      ) : (
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{productdescription}</div>
      )}
      {isOpen &&
        createdByDetails?.map((lineItem: any) => (
          <div className="border-line-lineItems">
            <DataTableCell>{lineItem.createdByName}</DataTableCell>
          </div>
        ))}
    </DataTableCell>
  ) : null;
};

/** Custom Rep/Covering cell */
export default PartDescriptionCell;
